import 'swiper/swiper-bundle.css'; 
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import 'aos/dist/aos.css';
import './styles/index.scss';

import './scripts';

